import React, { useState, useEffect } from 'react';
import CustomLoader from "../../common/Loader";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import {getRandomizedResultFullScale, randomizeParticipantFullScale} from "../../../services/formService.js"
import {executeSP} from "../../../services/utilService";

function FullScaleRandomizeViewer({PrimaryKey, buttonText, saveResponse, handleSaveResponse}) {
  const [randomizeResult, setRandomizeResult] = useState(null);
  const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
  const [resultDialogOpen, setResultDialogOpen] = useState(false);
  const [loadingResult, setLoadingResult] = useState(true);
  const [randomized, setRandomized] = useState(false);
  const [randomizedBy, setRandomizedBy] = useState(null);
  const [randomizedDateTime, setRandomizedDateTime] = useState(null);
  const [disabled, setDisabled] = useState(false);

  useEffect(() => {
    // get participant randomization details
    const fetchData = async () => {
        if (PrimaryKey && PrimaryKey !== '') {
            let {data} = await getRandomizedResultFullScale(PrimaryKey);
            if("Treatment" in data && (data["Treatment"] === 1 || data["Treatment"] === 2)) {
                setRandomizeResult(data['Treatment'] === 1 ? 'Propofol TIVA': 'Inhaled Volatile Anesthesia');
                setRandomizedBy(data['Randomized_By']);
                setRandomizedDateTime(new Date(data['Randomized_DateTime']).toLocaleString('en-ca', { timeZoneName: 'short' }));
                setRandomized(true);
            }
            else {
                debugger;
                // disable button if participant has not yet been randomized and surgery date is not today
                let today = new Date().toLocaleDateString('en-ca'); // get today's date in yyyy-mm-dd format
                let {data: surgeryDateData } = await executeSP(
                    'Custom.FullScaleGetParticipantSurgeryDate',
                    {'Participant_ID': PrimaryKey})
                debugger;
                if (surgeryDateData.length === 0 || surgeryDateData[0].SurgeryDate !== today) {
                   setDisabled(true);
                }
            }
        }
    }

    fetchData();
  }, [randomized, PrimaryKey]);

  const handleResult = async () => {
    setConfirmDialogOpen(false);
    setResultDialogOpen(true);
    setLoadingResult(true);

    if(!randomized) {
        let {data} = await randomizeParticipantFullScale(PrimaryKey);
        if (typeof data  == "number" && (data === 1 || data === 2)) {
            setRandomizeResult(data === 1 ? 'Propofol TIVA': 'Inhaled Volatile Anesthesia');
            setRandomized(true);
        }
        else { // Error
            setRandomizeResult(data);
        }
    }
    setLoadingResult(false);
  }

  const handleButtonClick = async () => {
      // if button is configured to save upon click, save form responses
      if (saveResponse && !randomized)
          await handleSaveResponse();
      setConfirmDialogOpen(true);
  }
  
  return (
    <>
        <button
            className={"btn " + (randomized ? 'btn-danger' : 'btn-success') + " col-md-2 mb-2 mt-2 mr-2"}
            onClick={handleButtonClick}
            disabled={disabled}
        >
            {randomized ? 'View Randomization Result' : buttonText}
        </button>
        {randomized ? 'Randomized by ' + randomizedBy + ' on ' + randomizedDateTime : ''}
        {disabled ? 'Randomize button locked: Surgery date is not today': ''}
        {/* Confirm Dialog */}
        <Dialog
            open={confirmDialogOpen}
            fullWidth
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title">Please confirm</DialogTitle>
            <DialogContent>
            <DialogContentText id="alert-dialog-description">
                {randomized ? 'This participant was randomized by User ' + randomizedBy + ' on ' + randomizedDateTime + 
                    '. Are you sure to unblind the result?' : 'This action cannot be undone. Are you sure to randomize this Participant?'}
            </DialogContentText>
            </DialogContent>
            <DialogActions>
            <button className="btn btn-outline-primary rounded-0 btn-sm" onClick={() => handleResult(true)}>
                Yes
            </button>
            <button className="btn btn-outline-danger rounded-0 btn-sm" onClick={() => setConfirmDialogOpen(false)} autoFocus>
                Cancel
            </button>
            </DialogActions>
        </Dialog>

        {/* Result Dialog */}
        <Dialog
            open={resultDialogOpen}
            fullWidth
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title">Randomization Result</DialogTitle>
            <DialogContent>
            <DialogContentText id="alert-dialog-description">
                {loadingResult ? <CustomLoader/> : randomizeResult}
            </DialogContentText>
            </DialogContent>
            <DialogActions>
            <button className="btn btn-outline-primary rounded-0 btn-sm" onClick={() => setResultDialogOpen(false)}>
                OK
            </button>
            </DialogActions>
        </Dialog>
    </>
  );
};

export default FullScaleRandomizeViewer;
